module.exports = __webpack_public_path__ + "static/media/ALTHAR_LOGO_blanco.ef47f527.svg";